import {
  ButtonAFY,
  ModalComponentAFY,
  sizes,
  variants,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { ButtonsContainer, Description, Title, useStyles } from "../style";

export const ModalDelete = (props: any) => {
  const classes = useStyles();
  return (
    <ModalComponentAFY
      openModal={props.openModalConfirmDelete}
      backgroundColor="#ffffff"
      onClose={() => {
        props.setOpenModalDelete(false);
      }}
      border={0}
      minWidthModal={"500px"}
      padding={30}
    >
      <div style={{ marginTop: "10px" }}>
        <Title>Eliminar usuario</Title>
        <Description>
        <strong>{props.modalTitle}</strong>?
        </Description>
        <ButtonsContainer>
          <div className={classes.button}>
            <ButtonAFY
              variant={variants.contained}
              size={sizes.large}
              label={"No"}
              onClick={() => {
                props.setOpenModalDelete(false);
              }}
            />
          </div>
          <div className={classes.button}>
            <ButtonAFY
              variant={variants.contained}
              size={sizes.large}
              label={"Si, eliminar"}
              backgroundColor="red"
              onClick={(e: { stopPropagation: () => void }) => {
                e.stopPropagation();
                props.onClickDelete();
              }}
            />
          </div>
        </ButtonsContainer>
      </div>
    </ModalComponentAFY>
  );
};
